import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Alert, Card, Row, Col } from 'react-bootstrap';
import './VotePage.css'; // Importar el archivo CSS para los estilos personalizados


function VotePage() {
  const [peopleList, setPeopleList] = useState([]);
  const [selectedVote, setSelectedVote] = useState('');
  const [selectedPerson, setSelectedPerson] = useState('');
  const [message, setMessage] = useState('');
  const [btnVolver, setBtnVolver] = useState(false);
  const [voted, setVoted] = useState(false);
  const [userId, setUserId] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Al montarse el componente, obtener la lista de personas excluyendo al usuario
  useEffect(() => {
    const token = searchParams.get('token'); // Obtener el token de la URL

    if (token) {
      const fetchPeopleList = async () => {
        try {
          const response = await fetch(`https://api.grekad.cfcunap.cl/api/verify-email?token=${token}`);
          const data = await response.json();
          if (data.success) {
            setPeopleList(data.peopleList);
            setUserId(data.userId); // Obtener el ID del usuario actual
            setBtnVolver(false);
          } else {
            setBtnVolver(true);
            setMessage('Error: '+data.message);
          }
        } catch (error) {
            setBtnVolver(true);
            setMessage('Error al cargar la lista de personas.');
        }
      };

      fetchPeopleList();
    } else {
      setMessage('Token inválido.');
      setBtnVolver(true);
    }
  }, [searchParams]);

  // Enviar el voto
  const handleVoteSubmit = async (e) => {
    e.preventDefault();
    if (!selectedVote) {
      setMessage('Por favor, selecciona una persona para votar.');
      return;
    }

    try {
      const response = await fetch('https://api.grekad.cfcunap.cl/api/submit-vote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, vote: selectedVote }),
      });

      const data = await response.json();
      if (data.success) {
        setVoted(true); // Marcar como votado
        setMessage('¡Gracias por tu voto!');
      } else {
        setMessage('Error al registrar el voto.');
      }
    } catch (error) {
      setMessage('Hubo un error al enviar tu voto.');
    }
  };
  const handleVote = async (personaId) => {
    const response = await fetch('https://api.grekad.cfcunap.cl/api/submit-vote', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, vote: personaId }),
    });

    const data = await response.json();

    if (data.success) {
      setMessage('Voto registrado correctamente.');
    } else {
      setMessage(data.message);
    }
  };
  // Si el usuario ya ha votado, redirigirlo a una página de agradecimiento o mostrar un mensaje
  if (voted) {
    return (
        <Container className="mt-5">
        <Alert variant='success'>Gracias por tu voto</Alert>
        <Button className="mt-3" onClick={() => navigate('/ingreso')}>Volver al inicio</Button>
      </Container>
    );
  }
  const handleVoteChange = (e) => {
    setSelectedVote(e.target.value);
    setSelectedPerson(e.target.value);
  };
  return (
    <Container className="mt-2">
      
        {message && <Alert variant={message.includes('Error') ? 'danger' : 'success'}>{message}</Alert>}
        {btnVolver?<Button className="mt-3  mb-4"  variant="outline-secondary" onClick={() => navigate('/ingreso')}>Volver al inicio</Button>:''}
        {peopleList.length ? (<h2 className="text-center display-4 mb-4">SELECCIONA A UN COMPAÑERO DE TRABAJO!</h2>): (
        <p></p>
      )}
        {peopleList.length ? (
        <Form onSubmit={handleVoteSubmit}>
            <Row>
          {peopleList.map((person) => (
            <Col sm={12} md={6} lg={4} key={person.id} className="mb-3">
            <Card className={`ticket-card shadow-sm ${selectedPerson === person.run ? 'selected' : ''}`}>
              <Card.Body  className="ticket-body">
                <Form.Check
                key={person.id}
                id={`person-${person.id}`}
                type="radio"
                
                name="vote"
                value={person.run}
                onChange={handleVoteChange}
                //onChange={(e) => setSelectedVote(e.target.value)}
                className="hidden-radio"
                />
                <label htmlFor={`person-${person.id}`} className="ticket-label">
                    {person.nombre}
                </label>
                
            </Card.Body>
            {selectedPerson === person.run && (
                <Card.Footer>
                    <div className="d-flex justify-content-center mt-4">
                        <Button type="submit" className="mt-2">
                            Votar!
                        </Button>
                    </div>
                </Card.Footer>
                    
                  
                )}
            
                </Card>
              </Col>
          ))}
          </Row >
      </Form>
    ) : (
        <p></p>
      )}
    </Container>
  );
}

export default VotePage;
